/** Carry each tab's local selection in the URL, including across reload and browser Back.
 * Only known query fields cross the tab boundary; no stored company data or redirect URLs.
 * Each tab keeps its own: Dagen its day and filters, Perioden its month (#273 v3.1), Oppfølging its area,
 * so moving between them never resets the one left behind. */
const pick = (source: URLSearchParams, keys: string[]) => {
  const out = new URLSearchParams();
  for (const key of keys) {
    const value = source.get(key);
    if (value) out.set(key, value);
  }
  return out;
};

export type OverviewTab = 'dagen' | 'perioden' | 'oppfolging';

export function overviewLinks(tab: OverviewTab, sp: URLSearchParams, base = '/hjem') {
  const own = (t: OverviewTab, nested: string) =>
    tab === t ? sp : new URLSearchParams(sp.get(nested) ?? '');
  const day = pick(own('dagen', 'dag'), ['d', 'lag', 'vis', 'sok', 'valgt']);
  const period = pick(own('perioden', 'periode'), ['mnd']);
  const queue = pick(own('oppfolging', 'oppfolging'), ['omrade', 'valgt']);
  const ctx: [string, string][] = [
    ['dag', day.toString()],
    ['periode', period.toString()],
    ['oppfolging', queue.toString()],
  ];
  const carry = (p: URLSearchParams, self: string) => {
    for (const [k, v] of ctx) if (k !== self && v) p.set(k, v);
    return p.size ? `?${p}` : '';
  };
  return {
    day: `${base}${carry(day, 'dag')}`,
    period: `/perioden${carry(period, 'periode')}`,
    queue: `/varsler${carry(queue, 'oppfolging')}`,
  };
}
